import { track } from "../track";

export const trackAvatarVideoUploadTry = () =>
  track({ event: "avatar_video_upload_try" });
